module.exports = __webpack_public_path__ + "fonts/OpenSans-SemiBold.7106bb83.woff2";